import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { uptimeApi } from 'core/api';
import persistedReducer from './persist-reducer';

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: persistedReducer,
    preloadedState: preloadedState as RootState | undefined,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }).concat(uptimeApi.middleware),
  });
}

export const store = setupStore({
  layout: {
    cookiesAccepted: localStorage.getItem('userCookiesConsent')
      ? JSON.parse(localStorage.getItem('userCookiesConsent')!).acceptedCookies
      : false,
    isOpen: false,
    showCookieBanner: true,
    activeModal: null,
  },
});
setupListeners(store.dispatch);
export type RootState = ReturnType<typeof persistedReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
